module.exports = __webpack_public_path__ + "static/img/apply2.3f4d4a02.png";